import React from 'react';

import {
  AddPetBanner,
  Greetings,
  PetsHealthCard,
  Resources,
} from './components';

import { useTrackOnMount } from '../../hooks';
import { EV9 } from '../../services/mixpanel';

import './HomeScreen.css';

const HomeScreen = () => {
  useTrackOnMount(EV9());

  return (
    <div className="Home-main-container">
      <Greetings />

      <PetsHealthCard />

      <AddPetBanner />

      <Resources />
    </div>
  );
};

export { HomeScreen };
